//C:\VUE3\platform\src\common\variableConst.js

const BASE_CONST = {

  /**
   * 전역으로 호출  url 관리 하는 파일, 이렇게 안하면  api 할때 경로를 직접 다 입력해줘야 한다.
   * 기술적으로 안써도 되지만 관리의 효율성을 위하여
   * vue.config.js 파일의 설정 가 맞춰 줘야 한다.
   * env 환경 변수 파일에서 직접 참조 가능 하나, 여기저기서 env 파일을 호출하는건 추천 하지 않는다.
   * 그래서 여기에 선언해서 쓴다.
   * 
   * */

     // BASE_API_URL : 'http://192.168.0.4:9000', // 개발
     // BASE_API_URL : 'http://192.168.0.4:5000', // 개발
//자기 도메인  https://mpnite.com
     MODE : process.env.VUE_APP_MODE,
  // ✅ SPA 자체(URL: https://mpnite.com/platform)를 가리키는 베이스 URL
     SITE_URL: process.env.VUE_APP_SITE_URL,
     BASE_API_URL : process.env.VUE_APP_API_URL,
     IMAGE_BASE_PATH : process.env.VUE_APP_IMAGE_BASE_PATH,
     BASE_FASTAPI_URL :  process.env.VUE_APP_BASE_FASTAPI_URL,
     PAYPAL_CLIENT_ID : process.env.VUE_APP_PAYPAL_CLIENT_ID,



};


export default BASE_CONST;